export default async function auth({ to, next, stores }) {
  const loginQuery = { path: '/login', query: { redirect: to.fullPath } };

  if (stores.auth.authUser) {
    return next();
  }

  try {
    await stores.auth.getAuthUser();
    if (stores.auth.authUser) {
      return next();
    }
  } catch (error) {
    // Silently fail if the user is not authenticated
  }

  return next(loginQuery);
}
